import sessionReducer from "modules/login/redux/session.slice";
import creditTransferReducer from "modules/credit-transfer/redux/credit-transfer.slice";
import transferHistoryReducer from "modules/transfer-history/redux/transfer-history.slice";

const rootReducer = {
  session: sessionReducer,
  creditTransfer: creditTransferReducer,
  transferHistory: transferHistoryReducer,
};

export default rootReducer;
